import { Client } from '../../client/Client';
import { PLACES_ENDPOINT } from '../../config/Client';

export class PlacesController {
  static getAll() {
    return Client.get(`${PLACES_ENDPOINT}`);
  }
}
